import React, { useState } from "react";
import { CalendlyLink } from "../SiteHeader";

const QS = [
  ["market", "The market you're selling into", [["Hot. Things sell in days.", 2], ["Balanced.", 1], ["Slow. Weeks, maybe months.", 0]]],
  ["carry", "Could your income carry both mortgage payments for a couple of months?", [["Comfortably.", 2], ["Tight, but yes.", 1], ["No.", -3]]],
  ["between", "Between houses, could you…", [["Stay with family or rent short-term.", 0], ["Nope. Straight across, one move.", 1]]],
  ["budget", "Your budget for the next place…", [["I know my equity roughly. It's fine.", 1], ["Depends a lot on what this one sells for.", -2]]],
];

const RESULTS = {
  buy: { tada: ["Buy first,", "then sell."], sub: "Your market moves fast, your income can carry the overlap, and you'd rather move once. Find the house. We'll make the timing work.",
    lineUp: ["Approval with and without your sale, so you know what you can write today", "A firm-sale plan with your realtor before you fall in love with anything", "Bridge financing ready to go the day your sale goes firm", "One lawyer for both sides, so the money lands in the right order"] },
  sell: { tada: ["Sell first,", "then buy."], sub: "Your budget rides on the sale price and carrying two payments would hurt. Sell, know your number to the dollar, then shop with a first-time-buyer-strength offer.",
    lineUp: ["A market evaluation from your realtor and your lender's payout statement", "A long possession date (60–90 days) or a short rent-back written into your sale", "Your rate held for up to 120 days while you shop", "Port and penalty rules from your current lender, before you list"] },
  line: { tada: ["Line them", "up."], sub: "Sell and buy at the same time, closings a few days apart, bridge covering the gap. A little choreography, and it's the path most of our clients take.",
    lineUp: ["Two approvals up front: with your sale and without it", "Closing dates a few days apart, sale first if we can manage it", "Bridge financing arranged the day your sale goes firm", "One real estate lawyer handling both transactions"] },
};

export function SellFirstHelper() {
  const [a, setA] = useState({});
  const done = QS.every(([k]) => a[k] !== undefined);
  const score = QS.reduce((s, [k, , opts]) => s + (a[k] === undefined ? 0 : opts[a[k]][1]), 0);
  const r = done ? RESULTS[score >= 4 ? "buy" : score <= 0 ? "sell" : "line"] : null;
  return (
    <section className="pq bh" data-testid="sell-first-helper">
      <div className="wrap">
        <div className="pq-head"><div className="eyebrow">Decisions, decisions · 4 questions</div><h2 className="display pq-h2">Sell first or buy first? <em>Let's settle it.</em></h2><p className="pq-lead">Four honest answers. One straight recommendation, plus the short list of what to line up.</p></div>
        <div className="pq-card bh-card">
          <div className="bh-qs">
            {QS.map(([k, q, opts]) => (
              <div className="bh-q" key={k}>
                <span className="pq-label bh-label">{q}</span>
                <div className="pq-chips">{opts.map(([label], i) => <button type="button" key={label} className={`pq-chip${a[k] === i ? " on" : ""}`} onClick={() => setA({ ...a, [k]: i })} data-testid={`sfh-${k}-${i}`}>{label}</button>)}</div>
              </div>
            ))}
          </div>
          {r ? (
            <div className="pq-result bh-result" data-testid="sfh-result">
              <h3 className="display pq-tada">{r.tada[0]} <span>{r.tada[1]}</span></h3>
              <p className="pq-sub">{r.sub}</p>
              <div className="bh-lineup"><span className="tag">What to line up</span><ul>{r.lineUp.map((t) => <li key={t}>{t}</li>)}</ul></div>
              <div className="pq-foot"><CalendlyLink className="btn" testId="sfh-cta">Map out my move</CalendlyLink><span className="pq-sass">Fifteen minutes. We'll bring the numbers.</span></div>
            </div>
          ) : <p className="pq-sass bh-wait" data-testid="sfh-waiting">{QS.filter(([k]) => a[k] === undefined).length} to go…</p>}
        </div>
      </div>
    </section>
  );
}
